var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[_c('b-col',[_c('p',{staticClass:"text-center"},[_vm._v("You are now disconnected.")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }